export const MANDATORY_FIELDS = 'please enter all mandatory fields ';
export const LOGIN_FIELDS = 'both fields are required';
export const INVALID_LOGIN = 'invalid username or password';
export const SERVER_ERROR = 'you can not be connected now due to server error';
export const CONVENTION_EXAMPLE='Si le 10ème caractère est un chiffre ,donner les 6 premières lettres.sinon,les 5 dernières lettres en commancent par la dernière'